import React, {Component, Fragment} from 'react';
import {connect} from 'react-redux';
import {Radio, DatePicker, Select, Button, Tooltip, Tag, Spin, Switch, Input, message, Alert} from 'antd';
import {InfoCircleOutlined, CheckOutlined, CloseOutlined} from '@ant-design/icons';
import driveLogo from '../../assets/img/google-drive.png';
import gestionXml from '../../Actions/gestionXml';
import {withRouter} from 'react-router';
import user from '../../Actions/user';
import statusService from '../../Actions/statusService';
import {orderListByKey} from '../../helpers';
import TableView from '../tableView';
import Download from '../download';
import DashboardButton from '../dashboardButton';
import {getStatusColor, getTaxPayer, renderStatusCell} from '../../helpers';
import {Link} from 'react-router-dom';
import moment, {max} from 'moment';
import TaxPayerVolume from '../TaxPayerVolume';
import dashboard from '../../Actions/dashboard';
import Dashboard from '../Dashboard/index';
import GoogleDriveMessage from '../_Generic/GoogleDriveMessage';
import PortalIntermittencyNotice from '../PortalIntermittencyNotice';
import InformationByDownloadType from './InformationByDownloadType';
import {sortByDate, sortStringByKey, sortByString} from '../../Helpers/TableSorter';
import {getFilterByColumnValue} from '../../Helpers/PortalHelpers';
import ModalEnhancedPlan from '../ModalEnhancedPlan';
import googleDrive from '../../Actions/googleDrive';
import Complements from '../../Catalogs/complements.json'
import TipoComprobanteWebPortal from '../../Catalogs/tipoComprobanteWebPortal.json'
import CFDITypes from '../../Catalogs/tipoComprobante.json'
import CFDIStatusCatalog from '../../Catalogs/estadoComprobante.json'
import CustomSelect from "../_Generic/Select/CustomSelect";
import RoleHelper from "../../Helpers/RoleHelper";
import DownloadBlock from '../downloadBlock';
import DashboardButtonBlock from '../dashboardButtonBlock';

const {getGoogleData} = googleDrive.actions;
const {setDataDownloadFiles, getDownloadedFiles, generateRequestDownloadFiles, getZipFromPath} = gestionXml.actions;
const {showDashboard, getDashboardData} = dashboard.actions;
const {getUserData, getRoleData} = user.actions;
const {getStatusSATDescargaMasiva} = statusService.actions;
const {RangePicker} = DatePicker;
const {Option} = Select;

class DownloadXmlTab extends Component {
    constructor(props) {
        super(props);
        const reference = this.handleSwitchChange;
        this.generateRequestDownloadFiles = this.generateRequestDownloadFiles.bind(this);
        this.actions = this.actions.bind(this);
        this.getZipFromPath = this.getZipFromPath.bind(this);
        this.getStatusSATDescargaMasiva = this.getStatusSATDescargaMasiva.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.isScrapingDisabled = this.isScrapingDisabled.bind(this);
        this.validateWebServiceRequest = this.validateWebServiceRequest.bind(this);
        this.handleChangeGeneratePdf = reference.bind(this, 'generatePDF');
        this.handleChangeGenerateReport = reference.bind(this, 'generateReport');
        this.handleChangeGoogleDrive = reference.bind(this, 'googleDrive');
        this.handleChangeIncludeStatus = reference.bind(this, 'includeCancellationDate');
        this.closeMessage = this.closeMessage.bind(this);
        this.state = {
            showModalEnhancement: false
        }
    }

    componentDidMount() {
        let query = {
            ...this.props.downloadsPagination,
            page: 1,
            perPage: 5
        }

        let queryCertificates = {
            ...this.props.certificatesPagination,
            page: 1,
            perPage: 200,
            isFiltered: true
        }
        this.props.getGoogleData();
        this.props.getDownloadedFiles(query)
        this.interval = setInterval(() => this.props.getDownloadedFiles(query), 60000);
        this.props.getUserData(queryCertificates);
        this.props.setDataDownloadFiles({
            startDate: '',
            endDate: '',
            rfcsToFilter: [],
            rfcTPAccount: "",
            cfdiType: null,
            cfdiComplement: null
        });
        this.props.getRoleData();
        this.props.getStatusSATDescargaMasiva();
    }

    componentWillUnmount() {
        clearInterval(this.interval);
    }

    render() {
        const {downloadXmls, isUserLoading, gDriveData, isFreePlan, email, roleHelper, isOverflow} = this.props;
        const {
            documents,
            type,
            startDate,
            endDate,
            generatePDF,
            googleDrive,
            rfcsToFilter,
            generateReport,
            driveMessageVisible,
            rfcTPAccount,
            cfdiType,
            cfdiComplement,
            CFDIStatus,
            includeCancellationDate
        } = downloadXmls;
        let disableScraping = this.isScrapingDisabled();
        return (
            <Fragment>
                <Dashboard/>
                {type === 'WebPortal' && <PortalIntermittencyNotice/>}
                {(gDriveData.name === '' && !isFreePlan) && <GoogleDriveMessage/>}
                {(isFreePlan && driveMessageVisible) &&
                    <DriveMessage closeMessage={this.closeMessage} history={this.props.history} email={email}/>}
                <div className="download-xmls-container">
                    <label htmlFor="" className="label block">
                        Tipo de descarga
                    </label>
                    <div className="flex-container-between">
                        <Radio.Group
                            onChange={this.onChangeDownloadType.bind(this)}
                            value={type}
                        >
                            <div className="radio-container">
                                <Radio value="WebService">Web Service</Radio>
                                <Tooltip
                                    placement="bottom"
                                    title="Esta forma de descarga tiene una limitante de hasta 200,000 registros por vez y el SAT puede demorar hasta 6 días naturales en regresar los registros">
                                    <Button type="text" icon={<InfoCircleOutlined/>}/>
                                </Tooltip>
                            </div>
                            <div className="radio-container">
                                <Radio disabled={disableScraping || !this.props.isScrappingEnabledByRole} value="WebPortal">Portal del SAT (Scraping)</Radio>
                                {disableScraping ?
                                    <Tooltip
                                        placement="bottom"
                                        title="No puedes realizar la solicitud de descarga mediante Scraping debido a que tu volumen pasa los 2,000 documentos">
                                        <Button type="text" icon={<InfoCircleOutlined style={{color: 'red'}}/>}/>
                                    </Tooltip>
                                    :
                                    !this.props.isScrappingEnabledByRole ?
                                    <Tooltip
                                        placement="bottom"
                                        title="No puedes realizar la solicitud de descarga mediante Scraping debido a que tu rol asignado no lo permite">
                                        <Button type="text" icon={<InfoCircleOutlined style={{color: 'red'}}/>}/>
                                    </Tooltip>
                                    :
                                    <Tooltip
                                        placement="bottom"
                                        title="Esta forma de descarga tiene una limitante de 2,000 documentos por día y podrás descargar los comprobantes de inmediato">
                                        <Button type="text" icon={<InfoCircleOutlined/>}/>
                                    </Tooltip>
                                }
                            </div>
                        </Radio.Group>
                    </div>
                    <InformationByDownloadType type={type}/>
                </div>
                <div className="filters-container">
                    <div className="input-container">
                        <label htmlFor="" className="label block">RFC de descarga:</label>
                        <Select
                            showSearch
                            allowClear
                            onClear={this.handleClearTaxId.bind(this)}
                            defaultValue={this.props.downloadXmls.taxId}
                            value={this.props.downloadXmls.taxId}
                            style={{width: 230}}
                            onSearch={this.handleSearchTaxId.bind(this)}
                            onChange={this.handleChangeTaxId.bind(this)}
                            loading={this.props.taxIdSearchLoading}
                        >
                            {
                                orderListByKey(this.props.userData, "taxId").map((element, index) => (
                                    <Option key={index} value={element.taxId}>
                                        {element.taxId}
                                    </Option>
                                ))}
                        </Select>
                    </div>
                    <div className="input-container">
                        <label htmlFor="" className="label block"> Documentos:</label>
                        <CustomSelect
                            defaultValue={documents}
                            style={{width: 230}}
                            onChange={this.handleChangeDocuments.bind(this)}
                            items={this.selectdocumentType(roleHelper, type)}
                        />
                    </div>
                    <div className="input-container">
                        <label htmlFor="" className="label block">Seleccionar Rango de fecha:</label>
                        <RangePicker
                            value={(startDate === '' || endDate === '' ? '' : [moment(startDate, 'MM-DD-YYYY'), moment(endDate, 'MM-DD-YYYY')])}
                            style={{width: 460}}
                            format="MM-DD-YYYY"
                            onChange={this.changeDatesRange.bind(this)}
                            disabledDate={this.disabledDate}
                        />
                    </div>
                    {
                        type === 'WebService' && <>
                            <div className="input-container">
                                <label htmlFor=""
                                       className="label block">{documents === 'Emision' ? 'RFC cliente' : 'RFC proveedor'}</label>
                                <Select
                                    mode="tags"
                                    defaultValue={rfcsToFilter}
                                    onChange={this.handleChangeRFCsFilter.bind(this)}
                                    style={{width: 170, display: 'inline-block'}}
                                    value={rfcsToFilter}
                                    tokenSeparators={[',']}
                                    dropdownClassName="d-none"
                                >
                                </Select>
                                {documents === 'Emision' && <small>Máximo 5 RFCs</small>}
                            </div>
                            <div className="input-container">
                                <label htmlFor=""
                                       className="label block">Estado</label>
                                <Select
                                    defaultValue={CFDIStatus}
                                    disabled={documents !== 'Emision'}
                                    onChange={this.handleChangeCFDIStatus.bind(this)}
                                    style={{width: 170, display: 'inline-block'}}
                                    value={CFDIStatus}
                                >
                                    {CFDIStatusCatalog.map(status => <Option key={status.key}
                                                                             value={status.key}>{status.label}</Option>)}
                                </Select>
                            </div>
                            <div className="input-container">
                                <label htmlFor=""
                                       className="label block">Tipo</label>
                                <CustomSelect
                                    defaultValue={cfdiType}
                                    onChange={this.handleCFDITypeChange.bind(this)}
                                    style={{width: 170, display: 'inline-block'}}
                                    value={cfdiType}
                                    items={this.selectCFDIType(roleHelper, documents)}
                                />
                            </div>
                            <div className="input-container">
                                <label htmlFor=""
                                       className="label block">Complemento</label>
                                <Select
                                    defaultValue={cfdiComplement}
                                    onChange={this.handleComplementChange.bind(this)}
                                    style={{width: 170, display: 'inline-block'}}
                                    value={cfdiComplement}
                                >
                                    <Option value={null}>Todos</Option>
                                    {Complements.map(c => <Option key={c.key} value={c.key}>{c.label}</Option>)}
                                </Select>
                            </div>
                        </>
                    }
                    {
                        type === 'WebPortal' &&
                            <div className="input-container">
                                <label htmlFor=""
                                       className="label block">Complemento</label>
                                <Select
                                    defaultValue={cfdiComplement}
                                    onChange={this.handleComplementChange.bind(this)}
                                    style={{width: 200, display: 'inline-block'}}
                                    value={cfdiComplement}
                                >
                                    {TipoComprobanteWebPortal.map(c => <Option key={c.key} value={c.key}>{c.label}</Option>)}
                                </Select>
                            </div>
                    }
                </div>
                <div className="extras-container filters-container" style={{marginTop: 0}}>
                    <TaxPayerVolume taxId={this.props.downloadXmls.taxId} documents={documents}/>
                    <div className="elements-wrapper" style={{margin: '10px 0 0 auto'}}>
                        <div className="input-container-inline" style={{display: 'flex', alignItems: 'center'}}>
                            <Switch
                                onChange={this.handleChangeGenerateReport}
                                checkedChildren={<CheckOutlined/>}
                                unCheckedChildren={<CloseOutlined/>}
                                checked={generateReport}
                                style={{width: '50px', margin: 'auto',}}
                                disabled
                            />
                            <label htmlFor="" className="label block" style={{marginLeft: '5px'}}>Reportes</label>
                        </div>
                        <div className="input-container-inline" style={{display: 'flex', alignItems: 'center'}}>
                            <Switch
                                onChange={this.handleChangeGeneratePdf}
                                checkedChildren={<CheckOutlined/>}
                                unCheckedChildren={<CloseOutlined/>}
                                checked={generatePDF}
                                style={{width: '50px', margin: 'auto'}}
                            />
                            <label htmlFor="" className="label block" style={{marginLeft: '5px'}}>Generar Facturas
                                PDF</label>
                        </div>
                        <div className="input-container-inline" style={{display: 'flex', alignItems: 'center'}}>
                            <Switch
                                onChange={this.handleChangeGoogleDrive}
                                checkedChildren={<CheckOutlined/>}
                                unCheckedChildren={<CloseOutlined/>}
                                checked={googleDrive}
                                disabled={gDriveData.name === ''}
                                style={{width: '50px', margin: 'auto'}}
                            />
                            <label htmlFor="" className="label block" style={{marginLeft: '5px'}}>Google Drive</label>
                        </div>
                        <div className="input-container-inline" style={{display: 'flex', alignItems: 'center'}}>
                            <Switch
                                onChange={this.handleChangeIncludeStatus}
                                checkedChildren={<CheckOutlined/>}
                                unCheckedChildren={<CloseOutlined/>}
                                checked={includeCancellationDate === true}
                                disabled={type !== 'WebService'}
                                style={{width: '50px', margin: 'auto'}}
                            />
                            <label htmlFor="" className="label block" style={{marginLeft: '5px'}}>Incluir fecha de cancelación</label>
                            <Tooltip title="La descarga tarda más porque se solicita al SAT la información de cancelación. Sin esta opción el reporte incluye el estatus (vigente/cancelado) pero no la fecha de cancelación.">
                                <InfoCircleOutlined style={{marginLeft: '5px', color: '#8c8c8c'}}/>
                            </Tooltip>
                        </div>
                        <div className="actions-container">
                            <Button type="primary" onClick={this.generateRequestDownloadFiles}>Generar
                                solicitud</Button>
                        </div>
                    </div>
                </div>
                <div className="line"></div>
                <h1 className="regular-text">Últimas solicitudes de Descarga</h1>
                <TableView
                    loading={this.props.tableLoading}
                    disablePagination
                    defaultPageSize={5}
                    columns={this.actions({isOverflow})}
                    data={this.props.downloadsRequested}
                />
                <div className="align-button-right">
                    <Link to='./status'>
                        <Button>Ver todas</Button>
                    </Link>
                </div>

                {((!this.props.tableLoading && !this.props.taxIdSearchLoading) && this.props.isLoading) &&
                    <div className="loading-container">
                        <Spin size="large" tip="Cargando"/>
                    </div>
                }
                <ModalEnhancedPlan
                    showModal={this.state.showModalEnhancement}
                    email={email}
                    onClick={this.closeModal.bind(this)}
                />
            </Fragment>
        );
    }

    rowAction(record, e) {
        if (record.requestType !== 'Validación EFOS' && record.statusRequest && record.statusRequest[0] === 'Completado') {
            this.props.getDashboardData(record.requestId);
            this.props.showDashboard(true);
        }
    }

    closeModal(value) {
        this.setState({showModalEnhancement: value});
    }

    closeMessage() {
        this.props.setDataDownloadFiles({driveMessageVisible: false});
    }

    isScrapingDisabled() {
        const {downloadXmls, taxpayerVolume} = this.props;
        const {documents, taxId} = downloadXmls;
        const MAX_DOCUMENTS_PORTAL_SCRAPPING = 15000;
        let taxIdFound = getTaxPayer(taxpayerVolume, taxId);
        if (taxIdFound) {
            if (documents.toLowerCase() === 'emision') {
                if (taxIdFound.issuingVolumeDaily > MAX_DOCUMENTS_PORTAL_SCRAPPING)
                    return true;
            } else {
                if (taxIdFound.receivingVolumeDaily > MAX_DOCUMENTS_PORTAL_SCRAPPING)
                    return true;
            }
        }

        return false;
    }

    updateRecords(page, pageSize) {
        let query = {
            ...this.props.downloadsPagination,
            page
        };

        this.props.updateDownloadsPagination(query);
        this.props.getDownloadedFiles(query);

    }

    getZipFromPath(filePath, event) {

        if (filePath) {
            if (filePath.includes('google.com'))
                window.open(filePath, '_blank');
            else
                this.props.getZipFromPath(filePath);
        }

        event.stopPropagation();
    }

    getStatusSATDescargaMasiva() {
        this.props.getStatusSATDescargaMasiva();
    }

    handleChangeDocuments(value) {
        // El SAT solo permite XML cancelados en Emitidos; Recepción queda fija en Vigente.
        const CFDIStatus = value === 'Emision' ? 'Todos' : 'Vigente';
        this.props.setDataDownloadFiles({documents: value, CFDIStatus});
        this.updateRFCFilter(this.props.downloadXmls.rfcsToFilter, value);
    }

    handleComplementChange(value) {
        this.props.setDataDownloadFiles({cfdiComplement: value});
    }

    handleChangeCFDIStatus(value) {
        this.props.setDataDownloadFiles({CFDIStatus: value});
    }

    handleCFDITypeChange(value) {
        this.props.setDataDownloadFiles({cfdiType: value});
    }

    handleChangeTaxId(value) {
        this.props.setDataDownloadFiles({taxId: value});
    }

    handleChangeRFCsFilter(values) {
        this.updateRFCFilter(values, this.props.downloadXmls.documents)
    }

    updateRFCFilter(values, documentType) {
        let maxValueLength = documentType === 'Emision' ? 5 : 1;
        if (values.length > maxValueLength) values.splice(maxValueLength, values.length - 1);
        this.props.setDataDownloadFiles({rfcsToFilter: values.map(val => val.toUpperCase())})
    }

    handleSearchTaxId(value) {
        this.populateTaxIdData(value);
    }

    handleClearTaxId() {
        this.populateTaxIdData('');
    }

    populateTaxIdData(value) {
        this.props.getUserData({
            ...this.props.certificatesPagination,
            page: 1,
            perPage: 200,
            filter: value,
            isFiltered: true
        });
    }

    onChangeDownloadType(e) {
        let result = {type: e.target.value, cfdiComplement: null, cfdiType: null};
        if (e.target.value === 'WebPortal') {
            result.rfcsToFilter = [];
        }
        // La fecha de cancelación solo aplica a Web Service.
        if (e.target.value !== 'WebService') {
            result.includeCancellationDate = false;
        }

        this.props.setDataDownloadFiles(result);
    }

    generateRequestDownloadFiles() {

        if (this.validateWebServiceRequest())
            this.props.generateRequestDownloadFiles(this.props.downloadXmls);
        else
            message.warning('El volumen de facturas de Emisión supera el máximo de descarga por Web Service, intenta con otros parámetros', 5);
    }

    validateWebServiceRequest() {
        const {downloadXmls, taxpayerVolume} = this.props;
        const {documents, taxId, startDate, endDate} = downloadXmls;
        const MAX_DOCUMENTS_WEB_SERVICE = 200000
        let taxIdFound = getTaxPayer(taxpayerVolume, taxId);
        let differenceBetweenDays = moment(endDate).diff(startDate, 'days');

        if (taxIdFound) {
            if (differenceBetweenDays >= 30) {
                if (documents.toLowerCase() === 'emision') {
                    if (taxIdFound.issuingVolumeMonthly >= MAX_DOCUMENTS_WEB_SERVICE)
                        return false;
                } else {
                    if (taxIdFound.receivingVolumeMonthly >= MAX_DOCUMENTS_WEB_SERVICE)
                        return false;
                }
            } else {
                if (documents.toLowerCase() === 'emision') {
                    if (taxIdFound.issuingVolumeDaily * differenceBetweenDays >= MAX_DOCUMENTS_WEB_SERVICE)
                        return false;
                } else {
                    if (taxIdFound.receivingVolumenDaily * differenceBetweenDays >= MAX_DOCUMENTS_WEB_SERVICE)
                        return false;
                }
            }
        }

        return true;
    }

    changeDatesRange(dates, dateStrings) {
        this.props.setDataDownloadFiles({startDate: dateStrings[0], endDate: dateStrings[1]});
    }

    disabledDate = (current) => {
        if (!current) return false;
        const today = moment().endOf('day');
        const fiveYearsAgo = moment().subtract(5, 'years').startOf('day');
        return current > today || current < fiveYearsAgo;
    }

    handleInputChange(e) {
        this.props.setDataDownloadFiles({rfcsToFilter: e.target.value.toUpperCase()});
    }

    handleThirdPartyAccountRFCChange(e) {
        this.props.setDataDownloadFiles({rfcTPAccount: e.target.value.toUpperCase()});
    }

    handleSwitchChange(key, checked) {
        const {isFreePlan} = this.props;
        if (key === 'generatePDF' && isFreePlan) {
            this.setState({showModalEnhancement: true});
            return;
        }
        this.props.setDataDownloadFiles({[key]: checked});
    }

    selectdocumentType = (roleHelper, tabActive) => {
        if(tabActive === 'WebService')
            return [
                {key: 'Emision', value: 'Emision', label: 'Emisión', disabled: !roleHelper.hasAccess(RoleHelper.ACTION_DOWNLOAD,RoleHelper.DOCUMENT_TYPE_EMITIDOS)},
                {key: 'Recepcion', value: 'Recepcion', label: 'Recepción', disabled: !roleHelper.hasAccess(RoleHelper.ACTION_DOWNLOAD,RoleHelper.DOCUMENT_TYPE_RECIBIDOS)}
            ]
        else
            return [
                {key: 'Emision', value: 'Emision', label: 'Emisión', disabled: !roleHelper.hasAllOptions(RoleHelper.ACTION_DOWNLOADWEBPORTAL,RoleHelper.DOCUMENT_TYPE_EMITIDOS)},
                {key: 'Recepcion', value: 'Recepcion', label: 'Recepción', disabled: !roleHelper.hasAllOptions(RoleHelper.ACTION_DOWNLOADWEBPORTAL,RoleHelper.DOCUMENT_TYPE_RECIBIDOS)}
            ]
    }
    selectCFDIType = (roleHelper, documentType) => {
        const documentTypeDict = {
            "Emision": "emision",
            "Recepcion": "recepcion"
        }

        return [
            {
                label: 'Todos',
                key: null,
                value: null,
                disabled: !roleHelper.hasAllOptions(RoleHelper.ACTION_DOWNLOAD, documentTypeDict[documentType])
            },
            ...CFDITypes.map(ct => ({
                'label': ct.label,
                'key': ct.key,
                'value': ct.key,
                'disabled': !roleHelper.hasAccess(RoleHelper.ACTION_DOWNLOAD, documentTypeDict[documentType], ct.key),
            }))
        ]
    }
    
    actions({isOverflow}) {
        let columns = [
            {
                title: 'Registro',
                dataIndex: 'createdDate',
                key: 'createdDate',
                sorter: (a, b) => sortByDate(a, b, 'createdDate'),
                sortDirections: ['descend', 'ascend'],
            },
            {
                title: 'RFC',
                dataIndex: 'taxId',
                key: 'taxId',
                sorter: (a, b) => sortStringByKey(a, b, 'taxId'),
                sortDirections: ['descend', 'ascend'],
            },
            {
                title: 'Rango de fechas',
                key: 'date',
                render: (tex, row) => (
                    <span>{row.dateFrom} - {row.dateTo}</span>
                ),
                sorter: (a, b) => sortByDate(a, b, 'dateFrom'),
                sortDirections: ['descend', 'ascend'],
            },
            {
                title: 'Tipo de descarga',
                dataIndex: 'requestType',
                key: 'requestType',
                sorter: (a, b) => sortStringByKey(a, b, 'requestType'),
                sortDirections: ['descend', 'ascend'],
            },
            {
                title: 'Tipo de documentos',
                dataIndex: 'document',
                render: (tex, row) => (
                    <span>{row.documentType}</span>
                ),
                sorter: (a, b) => sortStringByKey(a, b, 'documentType'),
                sortDirections: ['descend', 'ascend'],
            },
            {
                title: 'Filtro',
                dataIndex: 'filterBy',
                render: (text, row) => {
                    return <span>{getFilterByColumnValue(row)}</span>;
                },
                sorter: (a, b) => {
                    const one = getFilterByColumnValue(a);
                    const two = getFilterByColumnValue(b);
                    return sortByString(one, two);
                },
            },
            {
                title: 'Estatus',
                dataIndex: 'statusRequest',
                key: 'statusRequest',
                render: (text, row) => renderStatusCell(row.statusRequest, row.totalFiles),
                sorter: (a, b) => {
                    return sortByString(a.statusRequest[0], b.statusRequest[0]);
                },
                sortDirections: ['descend', 'ascend'],
            },
            {
                title: '',
                key: 'action',
                render: (text, row) => (

                    <div style={{display: 'flex', alignItems: 'center'}}>
                        {
                            row.processes.map((report, index) => {
                                return (
                                    isOverflow ? <DownloadBlock download={this.getZipFromPath} key={index} pos={index} report={report}/> : <Download download={this.getZipFromPath} key={index} pos={index} report={report}/>
                                )
                            })
                        }
                        {
                            row.requestType !== 'Validación EFOS' &&
                            (isOverflow ? <DashboardButtonBlock row={row}/> : <DashboardButton handleClic={this.rowAction.bind(this, row)} row={row}/>)
                        }

                    </div>
                )
            }
        ];
        return columns;
    }
}

const DriveMessage = ({closeMessage, history, email}) => {

    return (
        <Alert
            message={
                <div style={{display: 'flex', alignItems: 'center'}}>
                    <img src={driveLogo} loading="lazy" style={{paddingRight: '10px'}}/>
                    <p className="margin-0">
                        Conecta tu efisco® a Google Drive a partir del plan Base.
                        <span className="cursor" style={{textDecoration: 'underline'}} onClick={() => {
                            history.push(`/buy-license/user/${email}`)
                        }}>Quiero mejorar mi plan</span>
                    </p>
                </div>
            }
            closable
            onClose={() => {
                closeMessage()
            }}
        />
    )
}

const mapStateToProps = state => {
    let tableLoader = state._genericComponents.loading.find('tableLoading');
    let userDataLoader = state._genericComponents.loading.find('userLoading');
    let TaxIdSearchLoader = state._genericComponents.loading.find('taxIdSearchLoading');
    const roleHelper = new RoleHelper(state.user.role);
    const isScrappingEnabledByRole = roleHelper.hasAllOptions(RoleHelper.ACTION_DOWNLOADWEBPORTAL, RoleHelper.DOCUMENT_TYPE_EMITIDOS) ||
        roleHelper.hasAllOptions(RoleHelper.ACTION_DOWNLOADWEBPORTAL, RoleHelper.DOCUMENT_TYPE_RECIBIDOS)    
    return {
        downloadXmls: state.gestionXml.downloadXmls,
        downloadsRequested: state.gestionXml.downloadsRequested,
        userData: state.user.userData,
        tableLoading: tableLoader ? tableLoader.isLoading : false,
        taxIdSearchLoading: TaxIdSearchLoader ? TaxIdSearchLoader.isLoading : false,
        isLoading: state._genericComponents.loading.isCurrentlyLoading,
        isUserLoading: userDataLoader ? userDataLoader.isLoading : false,
        downloadsPagination: state.gestionXml.downloadsPagination,
        certificatesPagination: state.certificates.certificatesPagination,
        taxpayerVolume: state.taxpayer.taxpayerVolume,
        gDriveData: state.googleDrive.data,
        isFreePlan: state.license.isFreePlan,
        isOverflow: state.license.isOverflow,
        email: Object.keys(state.login.login).length > 0 ? state.login.login.values.username : state.register.registerData.email,
        isScrappingEnabledByRole,
        roleHelper
    };

};

const mapDispatchToProps = dispatch => {
    return {
        setDataDownloadFiles(data) {
            dispatch(setDataDownloadFiles(data));
        },
        getDownloadedFiles(data) {
            dispatch(getDownloadedFiles(data));
        },
        getUserData(query) {
            dispatch(getUserData(query));
        },
        generateRequestDownloadFiles(data) {
            dispatch(generateRequestDownloadFiles(data));
        },
        getZipFromPath(filePath) {
            dispatch(getZipFromPath(filePath))
        },
        getStatusSATDescargaMasiva() {
            dispatch(getStatusSATDescargaMasiva())
        },
        showDashboard(state) {
            dispatch(showDashboard(state));
        },
        getDashboardData(data) {
            dispatch(getDashboardData(data));
        },
        getGoogleData(data) {
            dispatch(getGoogleData(data));
        },
        getRoleData() {
            dispatch(getRoleData());
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(DownloadXmlTab));